import { createFileRoute } from "@tanstack/react-router"

import { GenHealthSettingsPage } from "@/features/settings/components/gen-health-settings-page"
import { requireSuperAdminRouteAccess } from "@/features/authz/require-super-admin-route-access"

export const Route = createFileRoute("/dashboard/settings/gen-health/")({
	component: GenHealthSettingsPage,
	beforeLoad: async ({ context }) => {
		await requireSuperAdminRouteAccess(context.queryClient)
	},
})
